<template>
  <div>
    <vs-row class="catBgClr mx-4">
      <vs-row>
        <h3 class="p-5 pb-4">Add Plaid Point Groups</h3>
      </vs-row>
      
      <vs-row>
        <vs-col vs-lg="8" vs-sm="8" class="pr-8">
          <p class="pl-5 pb-6 pt-0 mb-2 whiteText">
            These are WalletFlo Categories which can be linked to its corresponding Plaid Categories by editing its
        Subcategories
          </p>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="4" class="pr-4">
          <select
            class="w-full posSelect p-3 mb-2"
            v-model="selectedSortValue"
            @change="getCategories()"
          >
            <option
              v-for="exp in sortValues"
              :key="exp.value"
              :value="exp.value"
            >
              {{ exp.text }}
            </option>
          </select>
        </vs-col>
      </vs-row>
      <div class="w-full">
        <table class="w-full" style="border-spacing: 0px 12px;">
          <thead>
            <tr>
              <th style="padding: 0;">#</th>
              <th style="padding: 0;">Category Name</th>
              <th style="padding: 0;">Linked Plaid Categories</th>
              <th style="padding: 0;">Linked Merchant</th>
              <th style="padding: 0;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(category, index) in point_categories" :key="index"
              :style="{ 'background-color': index % 2 === 0 ? '#242426' : 'none' }">
              <td style="color: gray;">{{ index + 1 }}</td>
              <td>{{ truncateCategoryName(category.name) }}</td>
              <td>{{ category.numberOfPlaidCategories }}</td>
              <td>
                <div v-if="category.merchant">{{ category.merchant.name }}</div>
              </td>
              <td>
                <vs-button v-if="category._id != ''" class="mr-3" @click="toManage(category)">Manage</vs-button>
                <vs-button v-if="!category.merchant" @click="openMerchantModal(category)">Link Merchant</vs-button>
                <vs-button v-if="category.merchant" @click="unlinkMerchant(category)">Unlink
                  Merchant</vs-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <vs-row v-if="errors.categories.success">
        <p class="text p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
      </vs-row>

      <!-- Merchant Linking Modal -->
      <vs-popup class="holamundo" title="Link Merchants" :active.sync="merchantModal.status">
        <div class="merchant-modal-container">
          <v-select :options="merchants" v-model="selectedMerchant" label="name" placeholder="Select an option"
            @search="onSearch" />
          <vs-row class="mt-5 buttons-container">
            <vs-button class="mr-2" @click="linkMerchant">Save</vs-button>
            <vs-button @click="closeMerchantModal">Cancel</vs-button>
          </vs-row>
        </div>
      </vs-popup>

      <!-- Status Popups -->
      <vs-popup class="holamundo" title="Status" :active.sync="updateStatus.status">
        <h5>{{ updateStatus.msg }}</h5>
      </vs-popup>

      <vs-popup class="holamundo" title="Status" :active.sync="NoCategory.status" @close="closefunc()">
        <h5>{{ NoCategory.msg }}</h5>
      </vs-popup>
    </vs-row>
  </div>
</template>

<script>
import { PlusSquareIcon, MinusSquareIcon, MenuIcon } from "vue-feather-icons";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    MenuIcon,
  },
  data() {
    return {
      point_categories: [],
      merchants: [],
      selectedMerchant: null,
      errors: {
        categories: {
          msg: "",
          success: false,
        },
      },
      updateStatus: {
        msg: "",
        status: false,
      },
      NoCategory: {
        msg: "",
        status: false,
      },
      merchantModal: {
        status: false,
        currentCategory: null,
      },
      genericErrorMessage,
      toast,
      selectedSortValue: "emptyFirst",
      sortValues: [
        {
          text: "Default Sort: Linked Plaid Categories",
          value: "emptyFirst"
        },
        { text: "No Merchants Linked", value: "noMerchantsLinked" },
        { text: "Merchants Linked", value: "merchantsLinked" },
        { text: "Alphabetically", value: "alphabetically" }
      ]
    };
  },
  mounted() {
    this.getMerchants();
  },
  methods: {
    truncateCategoryName(name) {
      return name.length > 50 ? name.slice(0, 50) + '...' : name;
    },
    async getCategories() {
      this.$vs.loading({ background: "rgba(1,2,3,.2)" });
      try {
        const res = await this.$axios.get(
          `${this.$ApiKeys.BASE_URL}${this.$EndPoints.PointCategories}?type=plaid&sort=${this.selectedSortValue}`
        );
        this.$vs.loading.close();

        if (res.data.success) {
          this.point_categories = res.data.data;
          return this.point_categories;
        } else {
          this.toast(this.genericErrorMessage());
        }
      } catch (e) {
        if (e.response.status !== 401) {
          this.toast(this.genericErrorMessage());
        }
        this.$vs.loading.close();
      }
    },
    async toManage(inp) {
      await this.$router.push({
        path: "/point-categories/plaid-subcategories/" + inp._id,
      });
    },
    openMerchantModal(category) {
      this.merchantModal.currentCategory = category;  
      this.merchantModal.status = true;
      this.selectedMerchant = category.merchant;
      // console.log(this.selectedMerchant);
    },
    closeMerchantModal() {
      this.merchantModal.status = false;
      this.selectedMerchant = null; // Reset selected merchant
    },
    getMerchants() {
      this.$axios
        .get(this.$ApiKeys.BASE_URL + this.$EndPoints.FetchAllMerchants)
        .then((res) => {
          if (res.data.success) {
            console.log('res.data.data: ',);
            this.merchants = res.data.data.merchants; // Assuming the API returns a list of merchants
          }
        })
        .catch(() => {
          this.toast(this.genericErrorMessage());
        });
    },
    linkMerchant() {
      if (!this.selectedMerchant) {
        this.toast("Please select a merchant.");
        return;
      }
      this.$axios
        .patch(this.$ApiKeys.BASE_URL + this.$EndPoints.PatchPointCategory(this.merchantModal.currentCategory._id) + '?type=merchant', {
          merchantId: this.selectedMerchant._id,
        })
        .then((res) => {
          if (res.status === 200) {
            this.toast("Merchant linked successfully!");
            this.merchantModal.status = false;
            this.selectedMerchant = null; // Reset after linking
            this.getCategories();
          } else {
            this.toast(this.genericErrorMessage());
          }
        })
        .catch(() => {
          this.toast(this.genericErrorMessage());
        })
    },
    unlinkMerchant(category) {
      this.$axios
        .patch(this.$ApiKeys.BASE_URL + this.$EndPoints.PatchPointCategory(category._id) + '?type=merchant', {
          merchantId: null,
        })
        .then((res) => {
          if (res.status === 200) {
            this.toast("Merchant unlinked successfully!");
            this.getCategories();
          } else {
            this.toast(this.genericErrorMessage());
          }
        })
        .catch(() => {
          this.toast(this.genericErrorMessage());
        });
    },
  },
  created() {
    this.getCategories();
  },
};
</script>

<style>
.catBgClr {
  background-color: #1c1c1e;
  padding: 20px;
  border-radius: 10px;
}

.whiteText {
  color: white !important;
}

.manageButton {
  border-radius: 10px;
  font-size: 13px;
  height: 45px;
}

.merchant-modal-container {
  display: flex;
  min-height: 150px !important;
  flex-direction: column;
  justify-content: space-between;
}

.merchant-modal-container .v-select.vs--open + .buttons-container {
  margin-top: 320px !important;
}

.v-select {
  position: relative;
  z-index: 9999 !important;
}

.vs__dropdown-menu {
  position: absolute !important;
  z-index: 99999 !important;
  max-height: 300px !important;
}

/* Override any vs-popup styles that might be interfering */
.vs-popup {
  overflow: visible !important;
}

.vs-popup--content {
  overflow: visible !important;
}

.posSelect {
  background-color: #2c2c2e !important;
}
</style>
